const queryKeys = {
  auth: {
    user: "authUser",
    notifications: "authNotifications",
    stockNotifications: "authStockNotifications",
  },
  admin: {
    sliders: "adminSliders",
    categories: "adminCategories",
    categorySlug: "adminCategoriesSlug",
    brands: "adminBrands",
    brandSlug: "adminBrandSlug",
    brandsForSelect: "adminBrandsForSelect",
    colors: "adminColors",
    colorsForSelect: "adminColorsForSelect",
    deliveryAddresses: "adminDeliveryAddresses",
    vouchers: "adminVouchers",
    products: "adminProducts",
    product: "adminProduct",
    searchProducts: "adminSearchProducts",

    shopTheLooks: "adminShopTheLooks",
    shopTheLook: "adminShopTheLook",
    shopTheLookSlug: "adminShopTheLookSlug",
    shopTheLookProducts: "adminShopTheLookProducts",
    reviews: "adminReviews",
    review: "adminReview",
    orders: "adminOrders",
    order: "adminOrder",
    Payments: "adminPayments",
    users: {
      users: "adminUsersUsers",
      admins: "adminUsersAdmins",
    },
    misc: {
      siteSetting: "adminSiteSetting",
      contactMessages: "adminContactMessages",
      subscribers: "adminSubscribers",
      pages: "adminPages",
      page: "adminPage",
      faqs: "adminFaqs",
      emailTemplates: "adminEmailTemplates",
      emailTemplate: "adminEmailTemplate",
      pageSeo: "adminPageSeo",
    },
    aboutUs: {
      teams: "adminTeams",
      testimonials: "adminTestimonials",
    },
    blogs: "adminBlogs",
    blog: "adminBlog",
    blogSEO: "adminBlogSEO",
  },

  shop: {
    sliders: "shopSliders",
    searchDesktop: "SearchDesktop",
    productBySlug: "shopProductBySlug",
    latestProducts: "shopLatestProducts",
    productReviews: "shopProductReviews",
    recommended: "shopRecommendation",
    homeCategories: "shopHomeCategories",
    siteSetting: "shopSiteSettings",
    shopTheLook: "shopTheLooks",
    productsByShopTheLook: "shopproductsByShopTheLook",
    featuredProducts: "shopFeaturedProducts",
    categories: {
      categories: "shopCategories",
      productsByCategoryMeta: "shopProductsByCategoryMeta",
      productsByCategory: "shopProductByCategories",
    },
    special: {
      specialProducts: "shopSpecialProducts",
      specialByProducts: "shopSpecialByProducts",
    },
    addresses: "shopAddresses",
    Onsale: "shopOnsale",
    brand: "shopBrands",
    page: "shopPage",
    blogs: "shopBlogs",
    blog: "shopBlog",
    faqs: "shopFaqs",
  },
  user: {
    cart: "userCart",
    wishlist: "userWishlist",
    orders: "userOrders",
    order: "userOrder",
    reviews: "userReviews",
    review: "userReview",
  },
};

export default queryKeys;
